// client/src/components/ActivityLog.jsx
import { User } from 'lucide-react';

const ACTION_LABELS = {
  created:    'Created tender',
  updated:    'Updated',
  note_added: 'Added note',
  deleted:    'Deleted',
};

const FIELD_LABELS = {
  status:               'Status',
  price:                'Estimate value',
  estimated_value_pence:'Estimate value',
  submitted_value_pence:'Submitted value',
  final_value_pence:    'Final value',
  date_submitted:       'Submission date',
  submitted_at:         'Submission date',
  date_to_manager:      'Date to manager',
  issued_to_manager_at: 'Date to manager',
  date_approved:        'Date approved',
  manager_approved_at:  'Date approved',
  decision_date:        'Decision date',
  outcome_at:           'Decision date',
  estimator_user_id:    'Estimator',
  assigned_estimator_id:'Estimator',
  classification_id:    'Classification',
  idno_id:              'IDNO',
  asset_value:          'Asset value',
  idno_asset_value_pence:'Asset value',
  deadline:             'Deadline',
  tender_due_date:      'Deadline',
  project_name:         'Project name',
  company_id:           'Company',
  primary_contact_id:   'Contact',
  planned_start_date:   'Planned start date',
  initial_notes:        'Scope of Works',
  submission_notes:     'Submission notes',
  outcome_notes:        'Outcome notes',
  lost_feedback:        'Lost feedback',
  site_address:         'Site address',
  what3words:           'What3Words',
  site_postcode:        'Site postcode',
  poc_status:           'POC status',
  poc_type:             'POC type',
  is_archived:          'Archived',
  archive_outcome:      'Archive outcome',
  won_at:               'Won date',
};

function fmtVal(v) {
  if (v === null || v === undefined || v === '') return '—';
  const s = String(v);
  return s.length > 60 ? s.slice(0, 57) + '…' : s;
}

function parseEntry(e) {
  const oldObj = e.old_values || {};
  const newObj = e.new_values || {};
  const key    = Object.keys(newObj)[0] || Object.keys(oldObj)[0] || null;
  return {
    fieldLabel: key ? (FIELD_LABELS[key] || key.replace(/_/g, ' ')) : null,
    oldVal:     key ? oldObj[key] : null,
    newVal:     key ? newObj[key] : null,
  };
}

export default function ActivityLog({ entries = [] }) {
  if (!entries.length) return (
    <div style={{ color:'var(--text-muted)', fontSize:13, padding:'12px 0', textAlign:'center' }}>
      No activity recorded yet
    </div>
  );

  return (
    <div style={{ maxHeight: 300, overflow: 'auto' }}>
      {entries.map((e, i) => {
        const { fieldLabel, oldVal, newVal } = parseEntry(e);
        const hasChange = fieldLabel && (oldVal !== null || newVal !== null);
        return (
          <div key={i} style={{ display:'flex', gap:10, padding:'8px 0', borderBottom: i < entries.length-1 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
            <div style={{ width:28, height:28, borderRadius:'50%', background:'rgba(59,130,246,0.15)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
              <User size={13} color="#60a5fa" />
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:8 }}>
                <span style={{ color:'var(--text)', fontSize:12, fontWeight:500 }}>
                  {e.user_name || '?'}
                  {' '}
                  <span style={{ color:'var(--text-dim)', fontWeight:400 }}>
                    {ACTION_LABELS[e.action] || e.action}
                    {fieldLabel && ` — ${fieldLabel}`}
                  </span>
                </span>
                <span style={{ color:'var(--text-muted)', fontSize:10, whiteSpace:'nowrap', flexShrink:0 }}>
                  {new Date(e.created_at).toLocaleString('en-GB', { dateStyle:'short', timeStyle:'short' })}
                </span>
              </div>
              {hasChange && (
                <div style={{ color:'var(--text-muted)', fontSize:11, marginTop:2 }}>
                  <span style={{ textDecoration:'line-through' }}>{fmtVal(oldVal)}</span>
                  {' → '}
                  <span style={{ color:'var(--text-dim)' }}>{fmtVal(newVal)}</span>
                </div>
              )}
              {e.action === 'note_added' && newVal && (
                <div style={{ color:'var(--text-muted)', fontSize:11, marginTop:2, fontStyle:'italic' }}>"{fmtVal(newVal)}"</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
